module.exports = __webpack_public_path__ + "static/media/pantryLanding.8f2b0b7e.gif";